export default "__VITE_ASSET__Dn7huIgF__"